<template>
  <article
    class="content-container chart2-container"
    style="position: relative"
  >
    <ArticleTitle
      class="content-mg"
      :explainTitle="sectionTitle.kibotChart.sub"
      :mainTitle="$t(sectionTitle.kibotChart.main)"
    />

    <!-- <div
      class="coinlist-grid-container"
      ref="coinListRef"
      style="position: relative"
    >
      <lazyTablesCoinList @onRendered="handleTableMounted" />
    </div> -->

    <section class="chart kibot-chart__list-wrapper">
      <Draggable
        ref="draggableRef"
        :list="accordionList"
        :disabled="!enabled"
        item-key="name"
        class="list-group"
        ghost-class="ghost"
        :move="checkMove"
        @start="dragging = true"
        @end="dragging = false"
        handle=".handle"
      >
        <template #item="{ element }">
          <UiAccordion
            ref="accordionRef"
            :title="$t(element.title)"
            :tooltipMsg="element.tooltipMsg"
            :icon="element.icon"
            :iconStyle="element.iconStyle"
            :data-key="element.key"
            :viewPage="element.viewPage"
            :accordionList="accordionList"
            :isOpen="element.open"
            :class="{ active: element.open }"
          >
            <section v-if="element.open" v-html="element.content"></section>
            <lazyDominance
              v-if="element.open && element.key === 'dominance'"
            ></lazyDominance>

            <div
              class="coinlist-grid-container"
              :class="locale"
              ref="coinListRef"
              style="position: relative"
              v-if="element.open && element.key === 'coinList'"
            >
              <lazyTablesCoinList
                @onRendered="handleTableMounted"
                @openPopup="openPopup(element.viewPage)"
              />
            </div>

            <!-- <lazyBubble
              @mounted="renderHandler(element.key)"
              :ticker="ticker"
              v-if="element.open && element.key == 'bubble'"
            ></lazyBubble> -->

            <lazyAfter
              @mounted="renderHandler(element.key)"
              v-if="element.open && element.key == 'after'"
            ></lazyAfter>
          </UiAccordion>
        </template>
      </Draggable>
    </section>
    <AlertMsg v-show="alertMsg.visible" />
  </article>
</template>

<script setup>
import Draggable from "vuedraggable"; // vue3-draggable 대신 vuedraggable을 사용
import ArticleTitle from "@/components/ui/ArticleTitle.vue";
import UiAccordion from "@/components/ui/Accordion.vue";
import {
  ref,
  defineAsyncComponent,
  onMounted,
  watch,
  computed,
  onUnmounted,
} from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
const lazyTablesCoinList = defineAsyncComponent(() =>
  import("@/components/tables/coinList/CoinList.vue")
);
const lazyDominance = defineAsyncComponent(() =>
  import("@/views/chart/DominanceChartView.vue")
);
const lazyBubble = defineAsyncComponent(() =>
  import("@/components/chart/bubble/BubbleChart.vue")
);
const lazyAfter = defineAsyncComponent(() =>
  import("@/components/chart/after/AfterChart.vue")
);
import dominance_ico from "@/assets/images/icons/chart/dark/dominance_chart_ico.svg";
import bubble__ico from "@/assets/images/icons/chart/dark/bubble_chart_ico.svg";
import after_ico from "@/assets/images/icons/chart/dark/after_chart_ico.svg";
import chart_bubble from "@/components/explanation/chart_bubble.vue";
import chart_afterevent from "@/components/explanation/chart_afterevent.vue";
import chart_dominance from "@/components/explanation/chart_dominance.vue";
import chart_coinlist from "@/components/explanation/chart_coinlist.vue";
import AlertMsg from "@/components/bot/AlertMsg.vue";
// definePageMeta({
//     middleware: 'chart-auth',
// });
const accordionRef = ref(null);

const openPopup = (viewPage) => {
  if (accordionRef.value) {
    accordionRef.value.showPopup(viewPage);
  }
};

const store = useStore();
const alertMsg = computed(() => store.state.usePopupList.alertMsg);
const route = useRoute();
const { t, locale } = useI18n({ useScope: "global" });
// const router          = useCustomRouter();
const draggableRef = ref(null);
const coinListRef = ref(null);
const enabled = ref(true);
const dragging = ref(false);
// const userStore       = useUserStore();
// const chartSubScribe  = userStore.getChartSubscribeInfo();
const sectionTitle = ref({
  kibotChart: {
    main: "menu.kibotChart",
    sub: "Rising X",
  },
});
let userInfo = computed(() => store.state.userInfo.risingUserInfo);
let chartSubScribeInfo = computed(() => store.state.userInfo.chartInfo);
// const afterChartAuth = chartSubScribe.subsc_type == 'plan99' ? false : true;
const renderRef = ref({
  dominance: false,
  bubble: false,
});
function renderHandler(key) {
  renderRef.value[key] = true;
  const renderStatus = Object.values(renderRef.value);
  if (renderStatus.every((ob) => ob)) {
    scrollHandler(route.query.menuName);
  }
}
watch(userInfo, async (newVal) => {
  if (userInfo.value) {
    if (Object.keys(userInfo.value).length != 0) {
      if (userInfo.value.chart_subsc_wht == "N") {
        openAlertMsg("chartPurmission");
        return;
      }
      await store.dispatch("getCoinList/fetchCoin");
    } else {
      openAlertMsg(422);
      return;
    }
  } else {
    openAlertMsg(422);
    return;
  }
});
let accordionList = ref([]);
onMounted(async () => {
  // console.log("userInfo", userInfo.value);
  if (userInfo.value) {
    if (Object.keys(userInfo.value).length != 0) {
      if (userInfo.value.chart_subsc_wht == "N") {
        openAlertMsg("chartPurmission");
        return;
      }
      await store.dispatch("getCoinList/fetchCoin");
    } else {
      openAlertMsg(422);
      return;
    }
  }
  requestAnimationFrame(() => {
    // accordionList.value = JSON.parse(localStorage.getItem('chart_accordion')) || [
    accordionList.value = [
      {
        key: "dominance",
        title: "chart2.dominanceChart",
        content: "<div></div>",
        tooltipMsg: `Dominance description`,
        icon: dominance_ico,
        iconStyle: {
          width: "25px",
        },
        open: true,
        viewPage: chart_dominance,
      },
    ];
    accordionList.value.push({
      key: "coinList",
      title: "menu-dropdown.coinList",
      content: "<div></div>",
      tooltipMsg: `Coin List`,
      // icon: after_ico,
      // iconStyle: {
      //   width: "20px",
      // },
      open: true,
      viewPage: chart_coinlist,
    });
    if (
      chartSubScribeInfo.value &&
      chartSubScribeInfo.value.subsc_type != "plan99"
    ) {
      // accordionList.value.push({
      //   key: "bubble",
      //   title: "chart2.bubbleChart",
      //   content: "<div></div>",
      //   // content    : '<div style="height:450px; display:flex; align-items:center; justify-content: center; color:#FF929C">Comming Soon</div>',
      //   tooltipMsg: `Bubble description`,
      //   icon: bubble__ico,
      //   iconStyle: {
      //     width: "23px",
      //   },
      //   open: true,
      //   viewPage: chart_bubble,
      // });
      // accordionList.value.push({
      //   key: "after",
      //   title: "chart2.afterEventChart",
      //   content: "<div></div>",
      //   tooltipMsg: `After Event`,
      //   icon: after_ico,
      //   iconStyle: {
      //     width: "20px",
      //   },
      //   open: true,
      //   viewPage: chart_afterevent,
      // });
    }
    //after 차트 블러처리
    // if(afterChartAuth) {
    // accordionList.value.push(
    //     {
    //         key        : 'after',
    //         title      : 'After Event Chart',
    //         content    : '<div></div>',
    //         tooltipMsg : `After Event`,
    //         icon       : after_ico,
    //         iconStyle  : {
    //             width: '20px'
    //         },
    //         open       : true,
    //         viewPage   : chart_afterevent,
    //     }
    // )
    // }
  });
  // console.log("accordionList", accordionList.value);
});
onUnmounted(() => {
  store.commit("usePopupList/toggleAlertMsg", { visible: false });
});
const checkMove = async (e) => {
  // const list = e.relatedContext.list;
  // setTimeout(() => {
  //     const stringifiedList = JSON.stringify(list);
  //     localStorage.setItem('chart_accordion', stringifiedList);
  // }, 500);
};

watch(
  () => route.query.menuName,
  (newVal) => {
    scrollHandler(newVal);
  }
);

function scrollHandler(type) {
  if (alertMsg.value.visible) {
    window.scrollTo({ top: 0, behavior: "smooth" });
  } else {
    switch (type) {
      case "coin_list":
        if (coinListRef.value) {
          const top =
            coinListRef.value.getBoundingClientRect().top +
            window.scrollY -
            109;
          window.scrollTo({ top: top, behavior: "smooth" });
        }
        break;
      default:
        if (draggableRef.value) {
          const fi = draggableRef.value.list.findIndex((ob) => ob.key === type);
          const $dom = draggableRef.value.$el.children[fi];

          if ($dom) {
            const top =
              draggableRef.value.$el.children[fi].getBoundingClientRect().top +
              window.scrollY -
              114;
            window.scrollTo({ top, behavior: "smooth" });
          }
        }
        break;
    }
  }
}

function handleTableMounted() {
  scrollHandler(route.query.menuName);
}

function openAlertMsg(code) {
  store.commit("usePopupList/toggleAlertMsg", { visible: true, code: code });
}
</script>

<style scoped>
@import "@/assets/scss/pages/kibot/chart.scss";
</style>
